// CustomSliderArrow.js — as setas do carrossel de livros.
//
// ================= POR QUE ELAS FORAM REFEITAS (16/09/2026) =================
//
// Eram um círculo roxo translúcido (`bg-[#5b5bd6]/40`), com um ícone da fonte
// Unicons e um raio `rounded-full`. Três coisas que não existem em nenhum outro
// lugar deste site: o roxo não está na paleta (é resto de um mockup antigo), a
// fonte de ícones do site é a Bootstrap Icons, e o dono tirou as pílulas e os
// círculos do site inteiro quando encolheu a escala de raio.
//
// Resultado: o único controle da vitrine era justamente a peça que denunciava
// que aquilo tinha sido montado com pedaços de lugares diferentes.
//
// Agora elas são um OBJETO DA MESMA CAIXA DE FERRAMENTAS dos cards: quadrado de
// cantos quase retos, contorno de 2px na cor da sombra, sombra sólida deslocada
// que cresce quando o cursor chega — e laranja no hover, que é a cor de "clique
// aqui" em todo o resto. Um botão que parece com o que ele controla.
//
// `seta-carrossel` não estiliza nada por si só: é o gancho que o App.css usa
// para reposicionar as setas na faixa "Você poderia gostar", onde a lista tem
// um padding extra embaixo (a folga da expansão dos cards) que desloca o
// centro vertical. Sem a classe, o seletor teria que depender da estrutura
// interna do react-slick.
import React from "react";

const base =
  "seta-carrossel absolute top-1/2 -translate-y-1/2 z-30 w-11 h-11 md:w-12 md:h-12 " +
  "flex items-center justify-center cursor-pointer select-none " +
  "rounded-controle border-2 border-insigne-sombra bg-insigne-navy-soft " +
  "text-white text-xl md:text-2xl " +
  "shadow-[3px_3px_0_0_rgb(var(--c-sombra))] " +
  "transition-[transform,box-shadow,color,background-color] duration-200 " +
  "hover:text-insigne-orange hover:bg-insigne-navy-mid " +
  "hover:translate-y-[calc(-50%_-_2px)] hover:shadow-[5px_5px_0_0_rgb(var(--c-sombra))] " +
  // O clique afunda o botão: a sombra some e ele anda para dentro dela. É o
  // mesmo gesto do card que se levanta, ao contrário.
  "active:translate-x-[1px] active:shadow-[1px_1px_0_0_rgb(var(--c-sombra))]";

const CustomPrevArrow = ({ onClick }) => (
  <div onClick={onClick} className={`${base} left-0 md:left-1`} role="button" aria-label="Anterior">
    <i className="bi bi-chevron-left" />
  </div>
);

const CustomNextArrow = ({ onClick }) => (
  <div onClick={onClick} className={`${base} right-0 md:right-1`} role="button" aria-label="Próximo">
    <i className="bi bi-chevron-right" />
  </div>
);

export { CustomPrevArrow, CustomNextArrow };
